"use strict";
(() => {
  // Optional order correspondence never controls reward, navigation or checkout.
  function installOrderAttribution() {
    if (window.InShapeSurpriseOrderAttribution) return;
    var attribute = "__inshape_surprise_attribution__";
    var pendingToken = "";
    var pending = null;
    var persistedToken = "";
    var nextAttribution = null;
    function validate(value) {
      if (!value || typeof value.token !== "string" || value.token.length > 1500 || !/^[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+$/.test(value.token) || typeof value.expiresAt !== "string") return null;
      try {
        var encoded = value.token.split(".")[0].replace(/-/g, "+").replace(/_/g, "/");
        var claims = JSON.parse(atob(encoded.padEnd(Math.ceil(encoded.length / 4) * 4, "=")));
        var expires = Date.parse(value.expiresAt);
        if (claims.purpose !== "unboxing_order" || typeof claims.id !== "string" || !/^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/.test(claims.id)
          || claims.expiresAt !== value.expiresAt || !Number.isFinite(expires) || expires <= Date.now() || expires > Date.now() + 31 * 86400000) return null;
        return { token: value.token, expiresAt: value.expiresAt };
      } catch (_) { return null; }
    }
    function cartUrl() {
      var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
      var path = typeof root === "string" && root.charAt(0) === "/" && root.charAt(1) !== "/" && root.slice(-1) === "/" ? root + "cart/update.js"
        : (window.theme && window.theme.routes && window.theme.routes.cart_url || "/cart") + "/update.js";
      var url = new URL(path, window.location.origin);
      return url.origin === window.location.origin && /\/cart\/update\.js$/.test(url.pathname) && !url.search && !url.hash ? url.href : "";
    }
    function persist(value) {
      var attribution = validate(value);
      if (!attribution) return Promise.resolve(false);
      if (pending) {
        nextAttribution = pendingToken !== attribution.token ? attribution : null;
        return pending;
      }
      if (attribution.token === persistedToken) return Promise.resolve(false);
      try {
        var url = cartUrl();
        if (!url) return Promise.resolve(false);
        var attributes = {};
        attributes[attribute] = attribution.token;
        var controller = typeof AbortController === "function" ? new AbortController() : null;
        var timer = window.setTimeout(function () { if (controller) controller.abort(); }, 2500);
        pendingToken = attribution.token;
        var attempt = Promise.resolve().then(function () {
          return fetch(url, { method: "POST", credentials: "same-origin", headers: { "Content-Type": "application/json", Accept: "application/json" },
            body: JSON.stringify({ attributes: attributes }), keepalive: true, referrerPolicy: "no-referrer", signal: controller ? controller.signal : undefined });
        }).then(function (response) {
          if (response && response.ok) { persistedToken = attribution.token; return true; }
          return false;
        }).catch(function () { return false; }).finally(function () {
          window.clearTimeout(timer);
          if (pending === attempt) {
            pending = null; pendingToken = "";
            var next = nextAttribution; nextAttribution = null;
            if (next) persist(next);
          }
        });
        pending = attempt;
        return attempt;
      } catch (_) { return Promise.resolve(false); }
    }
    // This is only a client transport; the backend independently verifies the signature and order.
    window.InShapeSurpriseOrderAttribution = { validate: validate, persist: persist };
  }
  installOrderAttribution();

  function mount(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = "true";
    const stage = root.querySelector("[data-stage]");
    const offers = root.querySelector("[data-offers]");
    const preview = root.dataset.preview === "true";
    const link = window.InShapeSurpriseLink || {};
    const entrySources = ["hang_tag", "direct", "invitation_email", "receipt_email", "recovery_email"];
    const urlEntrySource = new URL(location.href).searchParams.get("entry_source");
    const requestedSource = entrySources.includes(urlEntrySource) ? urlEntrySource : entrySources.includes(link.entrySource) ? link.entrySource : "";
    const initialEntrySource = entrySources.includes(requestedSource) ? requestedSource : "hang_tag";
    let token = link.token || "";
    const tokenPurpose = value => {
      try {
        const payload = String(value).split(".")[0].replace(/-/g, "+").replace(/_/g, "/");
        return JSON.parse(atob(payload.padEnd(Math.ceil(payload.length / 4) * 4, "="))).purpose;
      } catch { return ""; }
    };
    let tokenKind = link.rewardKind === "shared" || tokenPurpose(token) === "unboxing" ? "shared" : "legacy";
    delete window.InShapeSurpriseLink;
    let apiBase = "";
    try {
      const url = new URL(root.dataset.apiBase);
      if (root.dataset.serviceClient === "true") apiBase = location.origin;
      else if (url.protocol === "https:" && !url.username && !url.password) apiBase = url.origin;
    } catch {}
    let copy = {};
    try { copy = JSON.parse(root.querySelector("[data-surprise-copy]").textContent); } catch {}
    const text = (key, values = {}) => {
      const value = key.split(".").reduce((result, part) => result?.[part], copy);
      return String(value ?? "").replace(/__([A-Z_]+)__/g, (match, name) => values[name.toLowerCase()] ?? match);
    };
    const definitions = window.InShapeSurpriseQuestions.map(q => ({
      ...q,
      title: text(`questions.${q.key}_title`),
      helper: text(`questions.${q.key}_helper`),
      placeholder: text(`questions.${q.key}_placeholder`),
      options: q.options?.map(option => ({ ...option, label: text(`questions.${q.key}_${option.id}`) }))
    }));
    const questions = definitions;
    const matches = (condition, answers) => Object.entries(condition || {}).every(([key, values]) => values.includes(answers[key]));
    const activeQuestions = () => questions.filter(q => !q.skip_when || !matches(q.skip_when, state.answers));
    const availableOptions = (q, answers = state.answers) => (q.options || []).filter(option => !option.visible_when || matches(option.visible_when, answers));
    const selectedOptions = (q, value, answers = state.answers) => Array.isArray(value) ? availableOptions(q, answers).filter(option => value.includes(option.id)).map(option => option.id) : [];
    const hasAnswer = (q, answers) => q.kind === "multi_select" ? selectedOptions(q, answers[q.key], answers).length > 0 : Boolean(answers[q.key]);
    const cleanDraft = input => {
      const answers = {};
      definitions.forEach(q => {
        const value = input?.[q.key];
        if (q.skip_when && matches(q.skip_when, answers)) return;
        if (q.kind === "text" && typeof value === "string") answers[q.key] = value.slice(0, q.max_length || 2000);
        else if (q.kind === "multi_select") {
          const selected = selectedOptions(q, value, answers);
          if (selected.length && !(q.mutually_exclusive_groups || []).some(group => selected.filter(id => group.includes(id)).length > 1)) answers[q.key] = selected;
        }
        else if (availableOptions(q, answers).some(option => option.id === value)) answers[q.key] = value;
      });
      return answers;
    };
    const storageKey = `inshape.unboxing.${preview ? "preview" : "draft"}.v5`;
    const previousStorageKey = storageKey.replace(".v5", ".v4");
    const esc = value => String(value ?? "").replace(/[&<>"']/g, char => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[char]));
    const previewReward = () => ({ amount: 20, minimum: 0, includesFreeShipping: false, code: "PREVIEW-SURPRISE20", kind: "shared", status: "active", expiresAt: null, redeemed: false });
    const newSubmissionKey = () => Array.from(crypto.getRandomValues(new Uint8Array(32)), byte => byte.toString(16).padStart(2, "0")).join("");
    let state = { phase: "game", step: 0, answers: {}, variant: "cards", revision: 0, visit: crypto.randomUUID(), entrySource: initialEntrySource, busy: false, error: "", reward: null, completed: false, isTest: false, quizFinished: false, pendingAnswer: null, submissionKey: "", submissionFingerprint: "" };
    let polls = 0;
    let pollTimer;
    let chooseTimer;
    let hadVariant = false;
    try {
      const draft = JSON.parse(sessionStorage.getItem(storageKey) || sessionStorage.getItem(previousStorageKey) || "null");
      if (draft && !token) {
        hadVariant = ["cards", "wheel", "scratch"].includes(draft.variant);
        const answers = cleanDraft(draft.answers);
        const steps = questions.filter(q => !q.skip_when || !matches(q.skip_when, answers));
        const missingQuestion = steps.findIndex(q => q.required && !hasAnswer(q, answers));
        const pendingQuestion = steps.findIndex(q => q.kind === "multi_select" && q.key === draft.pendingAnswer);
        const nextQuestion = pendingQuestion !== -1 && (missingQuestion === -1 || pendingQuestion < missingQuestion) ? pendingQuestion : missingQuestion;
        const quizFinished = draft.quizFinished === true && nextQuestion === -1;
        const previewCompleted = preview && draft.completed === true && quizFinished;
        if (!preview && draft.sharedToken && tokenPurpose(draft.sharedToken) === "unboxing") { token = draft.sharedToken; tokenKind = "shared"; }
        const sharedCompleted = !preview && tokenKind === "shared" && Boolean(token) && draft.completed === true;
        state = { ...state, answers, quizFinished, pendingAnswer: pendingQuestion !== -1 ? draft.pendingAnswer : null, variant: hadVariant ? draft.variant : "cards", visit: draft.visit || state.visit, entrySource: entrySources.includes(requestedSource) ? requestedSource : entrySources.includes(draft.entrySource) ? draft.entrySource : initialEntrySource,
          phase: previewCompleted || sharedCompleted ? "reward" : quizFinished ? "identity" : draft.phase === "questions" || Object.keys(answers).length ? "questions" : "game",
          completed: previewCompleted || sharedCompleted, reward: previewCompleted ? previewReward() : sharedCompleted ? draft.reward : null,
          submissionKey: /^[a-f0-9]{64}$/.test(draft.submissionKey) ? draft.submissionKey : "", submissionFingerprint: typeof draft.submissionFingerprint === "string" ? draft.submissionFingerprint : "",
          step: nextQuestion === -1 ? steps.length - 1 : Math.max(0, nextQuestion) };
      }
    } catch {}
    function save() {
      try { sessionStorage.setItem(storageKey, JSON.stringify({ answers: state.answers, variant: state.variant, visit: state.visit, entrySource: state.entrySource, phase: state.phase, quizFinished: state.quizFinished, pendingAnswer: state.pendingAnswer, completed: state.completed && (preview || tokenKind === "shared"), reward: preview || tokenKind === "shared" ? state.reward : null, sharedToken: !preview && tokenKind === "shared" ? token : "", submissionKey: state.submissionKey, submissionFingerprint: state.submissionFingerprint })); } catch {}
    }
    async function prepareSubmission(email) {
      const answers = cleanDraft(state.answers);
      const payload = JSON.stringify({ email: String(email).trim().toLowerCase(), answers, variant: state.variant, visit: state.visit });
      const digest = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(payload));
      const fingerprint = Array.from(new Uint8Array(digest), byte => byte.toString(16).padStart(2, "0")).join("");
      if (!state.submissionKey || state.submissionFingerprint !== fingerprint) {
        state.submissionKey = newSubmissionKey();
        state.submissionFingerprint = fingerprint;
      }
      // Save the request proof before network I/O so a lost response can be retried safely.
      save();
      return { email: String(email).trim().toLowerCase(), answers, variant: state.variant, visit: state.visit, entrySource: state.entrySource, submissionKey: state.submissionKey };
    }
    function rememberSharedToken() {
      const savedLink = { token, view: "reward", rewardKind: "shared", entrySource: state.entrySource };
      try { sessionStorage.setItem("inshape.unboxing.personal-link", JSON.stringify(savedLink)); } catch {}
      const url = new URL(location.href);
      url.searchParams.delete("token"); url.searchParams.delete("reward_kind"); url.searchParams.delete("experience_view");
      if (["verify", "reward"].includes(url.searchParams.get("view"))) url.searchParams.delete("view");
      url.hash = new URLSearchParams({ token, view: "reward", reward_kind: "shared" }).toString();
      history.replaceState(null, "", url.pathname + url.search + url.hash);
    }
    function event(name) {
      if (preview || (state.isTest && tokenKind !== "shared") || !apiBase) return;
      const target = `${apiBase}/api/journey`;
      const payload = { visit: state.visit, variant: state.variant, event: name, entrySource: state.entrySource };
      if (window.InShapeUnboxingQA) return window.InShapeUnboxingQA.postJourney(target, payload);
      return Promise.resolve(false);
    }
    function persistOrderAttribution(data) {
      if (preview || tokenKind !== "shared" || state.isTest || data?.tracking?.isTest === true || data?.tracking?.environment !== "production") return;
      try { window.InShapeSurpriseOrderAttribution.persist(data.orderAttribution); } catch {}
    }
    async function api(path, body) {
      if (!apiBase) throw new Error(text("errors.not_ready"));
      const response = await fetch(`${apiBase}/api/${path}`, { method: body ? "POST" : "GET", credentials: "omit", headers: window.InShapeUnboxingQA ? window.InShapeUnboxingQA.headers(`${apiBase}/api/${path}`, body ? { "Content-Type": "application/json" } : {}) : body ? { "Content-Type": "application/json" } : {}, body: body ? JSON.stringify(body) : undefined, cache: "no-store", referrerPolicy: "no-referrer", signal: AbortSignal.timeout(30000) });
      let data;
      try { data = await response.json(); } catch { throw new Error(text("errors.connection")); }
      if (!response.ok || !data.ok) {
        const error = new Error(data.message || text("errors.retry")); error.status = response.status; throw error;
      }
      return data;
    }
    function prize() {
      return `<div class="ish-surprise__prize"><h1 class="d">${esc(text("general.you_have_got"))}<strong>${esc(text("general.reward_offer"))}</strong></h1></div>`;
    }
    function fine(shared = false) {
      return shared ? `<p class="ish-surprise__reward-terms">${esc(text("general.shared_reward_terms"))}</p>` : `<details class="ish-surprise__terms"><summary>${esc(text("general.reward_terms"))}</summary><p>${esc(text("general.reward_terms_body"))}</p></details>`;
    }
    function error() {
      return state.error ? `<p class="ish-surprise__error" role="alert">${esc(state.error)}</p>` : "";
    }
    function render(focus = true) {
      clearTimeout(pollTimer);
      if (state.completed && state.phase === "questions") state.phase = "reward";
      root.dataset.phase = state.phase;
      root.querySelector("[data-reset]").hidden = state.phase !== "game";
      offers.hidden = true;
      offers.innerHTML = "";
      const renderers = { game, questions: question, identity, sent, verify, reward, failure };
      (renderers[state.phase] || failure)();
      if (focus) {
        const heading = stage.querySelector(state.phase === "questions" ? "h2" : "h1,h2");
        if (heading) { heading.setAttribute("tabindex", "-1"); heading.focus({ preventScroll: true }); }
      }
    }
    function game() {
      const title = text(state.variant === "scratch" ? "game.scratch_title" : "game.reveal_title");
      const helper = text(`game.${state.variant}_helper`);
      stage.innerHTML = `<h1 class="d ish-surprise__title">${esc(title)}</h1><p class="ish-surprise__helper">${esc(helper)}</p>${window.InShapeSurpriseDelight.markup(state.variant, copy.game)}`;
      window.InShapeSurpriseDelight.mount(stage, state.variant, () => {
        event("reward_revealed"); event("quiz_started");
        state.phase = "questions"; state.step = 0; save(); render();
      }, copy.game);
    }
    function question() {
      const steps = activeQuestions();
      state.step = Math.min(state.step, steps.length - 1);
      const q = steps[state.step];
      const options = availableOptions(q);
      const last = state.step === steps.length - 1;
      const isText = q.kind === "text";
      const isMulti = q.kind === "multi_select";
      const title = isText && !q.required ? text("general.optional_label", { title: q.title }) : q.title;
      const selected = isMulti ? selectedOptions(q, state.answers[q.key]) : [];
      const choices = `<div class="ish-surprise__options${isMulti ? " ish-surprise__choices--multi" : ""}" role="group" aria-label="${esc(q.title)}" ${isMulti ? `aria-describedby="AnswerHelp-${root.id}"` : ""}>${options.map(answer => `<button type="button" class="ish-surprise__option${isMulti ? " ish-surprise__choice--multi" : ""}" data-answer="${esc(answer.id)}" ${isMulti ? `role="checkbox" aria-checked="${selected.includes(answer.id)}"` : `aria-pressed="${answer.id === state.answers[q.key]}"`} ${state.busy ? "disabled" : ""}>${isMulti ? `<span class="ish-surprise__check" aria-hidden="true"></span><span class="ish-surprise__choice-label">${esc(answer.label)}</span>` : esc(answer.label)}</button>`).join("")}</div>`;
      const textMarkup = `<p class="ish-surprise__extra-helper">${esc(q.helper)}</p><label class="visually-hidden" for="Feedback-${root.id}">${esc(title)}</label><textarea class="ish-surprise__feedback" id="Feedback-${root.id}" name="${esc(q.key)}" maxlength="${q.max_length || 2000}" placeholder="${esc(q.placeholder)}" ${state.busy ? "disabled" : ""}>${esc(state.answers[q.key] || "")}</textarea>`;
      const answerMarkup = isText || isMulti ? `<form data-final-answer class="ish-surprise__form">${isText ? textMarkup : `<p id="AnswerHelp-${root.id}" class="ish-surprise__extra-helper">${esc(q.helper)}</p>${choices}`}<button class="ish-surprise__primary" type="submit" ${state.busy || (q.required && !hasAnswer(q, state.answers)) ? "disabled" : ""}>${esc(text("general.continue"))}</button></form>` : choices;
      stage.innerHTML = `${prize()}<p class="ish-surprise__progress">${esc(text("general.progress", { step: state.step + 1, total: steps.length }))}</p><h2 class="ish-surprise__question${q.key === "problem_to_solve" ? " ish-surprise__question--goal" : ""}">${esc(title)}</h2>${answerMarkup}${error()}${state.step > 0 ? `<button type="button" class="ish-surprise__text-button" data-back ${state.busy ? "disabled" : ""}>${esc(text("general.back"))}</button>` : ""}`;
      const submitAnswer = async value => {
        if (state.busy || (isText ? q.required && !value : isMulti ? !selectedOptions(q, value).length : !options.some(option => option.id === value))) return;
        state.busy = true; state.error = "";
        if (q.key === "tank_feel" && state.answers.tank_feel !== value) { delete state.answers.feel_detail; state.pendingAnswer = null; }
        state.answers[q.key] = value;
        if (isText) { if (value.trim()) event("feedback_provided"); }
        else event(`answered_${q.key}`);
        save(); render(false);
        try {
          if (token && tokenKind === "legacy" && !preview) {
            const data = await api("response", { token, source: "hang_tag", answers: state.answers, revision: state.revision, complete: last });
            Object.assign(state, { revision: data.revision, reward: data.reward, completed: data.completed, isTest: data.isTest });
          }
          chooseTimer = setTimeout(() => {
            state.busy = false;
            if (isMulti) state.pendingAnswer = null;
            if (!last) state.step++;
            else {
              state.quizFinished = true;
              state.phase = token && tokenKind === "legacy" && !preview ? "reward" : "identity";
            }
            save(); render();
          }, last || matchMedia("(prefers-reduced-motion: reduce)").matches ? 0 : 180);
        } catch (e) { state.error = e.message; state.busy = false; render(false); }
      };
      stage.querySelectorAll("[data-answer]").forEach(button => button.onclick = () => {
        if (!isMulti) { submitAnswer(button.dataset.answer); return; }
        if (state.busy) return;
        const id = button.dataset.answer;
        state.pendingAnswer = q.key;
        const current = selectedOptions(q, state.answers[q.key]);
        const conflicts = (q.mutually_exclusive_groups || []).find(group => group.includes(id)) || [];
        state.answers[q.key] = selectedOptions(q, current.includes(id) ? current.filter(value => value !== id) : [...current.filter(value => !conflicts.includes(value)), id]);
        stage.querySelectorAll("[data-answer]").forEach(option => option.setAttribute("aria-checked", String(state.answers[q.key].includes(option.dataset.answer))));
        stage.querySelector("[type=submit]").disabled = !hasAnswer(q, state.answers);
        save();
      });
      const feedback = stage.querySelector("textarea");
      if (feedback && isText) feedback.oninput = e => { state.answers[q.key] = e.target.value; save(); };
      const form = stage.querySelector("[data-final-answer]");
      if (form) form.onsubmit = e => {
        e.preventDefault();
        if (isText) state.answers[q.key] = String(new FormData(e.currentTarget).get(q.key) || "").trim();
        submitAnswer(state.answers[q.key]);
      };
      stage.querySelector("[data-back]")?.addEventListener("click", () => { if (!state.busy && state.step > 0) { state.step--; state.error = ""; render(); } });
    }
    function identity() {
      stage.innerHTML = `${prize()}<form data-identify class="ish-surprise__form" aria-busy="${state.busy}"><div class="ish-surprise__field"><label class="visually-hidden" for="OrderEmail-${root.id}">${esc(text("general.email_placeholder"))}</label><input id="OrderEmail-${root.id}" name="email" type="email" autocomplete="email" maxlength="254" required placeholder="${esc(text("general.email_placeholder"))}"></div><button class="ish-surprise__primary" type="submit" ${state.busy ? "disabled" : ""}>${esc(text("general.unlock_reward"))}</button><p class="ish-surprise__receipt-note">${esc(text("general.email_receipt_note"))}</p><span class="visually-hidden" data-submit-status role="status"></span></form>${error()}`;
      stage.querySelector("form").onsubmit = async e => {
        e.preventDefault(); if (state.busy || state.completed) return;
        const email = new FormData(e.currentTarget).get("email");
        const button = stage.querySelector("[type=submit]");
        const input = stage.querySelector("[name=email]");
        const form = e.currentTarget;
        state.busy = true; state.error = ""; form.setAttribute("aria-busy", "true"); input.disabled = true; button.disabled = true; button.textContent = text("general.unlocking");
        stage.querySelector("[data-submit-status]").textContent = text("general.unlocking");
        stage.querySelector("[role=alert]")?.remove();
        try {
          const request = await prepareSubmission(email);
          if (preview) { state.reward = previewReward(); state.completed = true; state.isTest = true; }
          else {
            if (window.InShapeUnboxingQA) await window.InShapeUnboxingQA.flushJourney(750);
            const data = await api("unboxing-complete", request);
            if (data.questionnaire !== "unboxing" || !data.completed || data.reward?.kind !== "shared" || tokenPurpose(data.token) !== "unboxing") throw new Error(text("errors.connection"));
            token = data.token; tokenKind = "shared";
            Object.assign(state, { reward: data.reward, revision: data.revision, completed: data.completed, isTest: data.tracking?.isTest === true, visit: data.tracking?.visitId || state.visit });
            rememberSharedToken();
            persistOrderAttribution(data);
          }
          state.phase = "reward"; state.busy = false; save(); render();
        } catch (e) {
          state.error = e.message;
          form.insertAdjacentHTML("afterend", error());
          form.setAttribute("aria-busy", "false"); input.disabled = false; button.disabled = false; button.textContent = text("general.unlock_reward");
          stage.querySelector("[data-submit-status]").textContent = "";
        } finally { state.busy = false; }
      };
    }
    function sent() {
      stage.innerHTML = `${prize()}<h2 class="ish-surprise__question">${esc(text("general.check_inbox"))}</h2><p class="ish-surprise__helper">${esc(text("general.check_inbox_body"))}</p>${preview ? `<button class="ish-surprise__primary" data-demo-verify>${esc(text("general.continue_preview"))}</button>` : ""}`;
      stage.querySelector("[data-demo-verify]")?.addEventListener("click", () => { state.phase = "verify"; render(); });
    }
    function verify() {
      stage.innerHTML = `${prize()}<button class="ish-surprise__primary" data-confirm ${state.busy ? "disabled" : ""}>${esc(text(state.busy ? "general.verifying" : "general.claim_reward"))}</button>${error()}${state.error ? `<button class="ish-surprise__text-button" data-new-link>${esc(text("general.send_new_link"))}</button>` : ""}`;
      stage.querySelector("[data-new-link]")?.addEventListener("click", freshStart);
      stage.querySelector("[data-confirm]").onclick = async () => {
        if (state.busy) return;
        state.busy = true; state.error = ""; render(false);
        try {
          if (preview) {
            if (!state.reward) state.reward = previewReward();
            state.completed = true; state.phase = "reward"; state.busy = false; save(); render();
          } else {
            const data = await api("verify", { token });
            const next = new URL(data.survey_url);
            if (next.origin !== location.origin || next.pathname !== location.pathname) throw new Error(text("errors.return_page"));
            const previewId = new URL(location.href).searchParams.get("preview_theme_id");
            if (previewId) next.searchParams.set("preview_theme_id", previewId);
            const templateView = new URL(location.href).searchParams.get("view");
            if (templateView && !["verify", "reward"].includes(templateView)) next.searchParams.set("view", templateView);
            location.replace(next.href);
          }
        } catch (e) { state.error = e.message; state.busy = false; render(false); }
      };
    }
    function reward() {
      const r = state.reward;
      const shared = r?.kind === "shared";
      const demo = preview || (!shared && state.isTest);
      const expired = r && !shared && r.expiresAt && Date.parse(r.expiresAt) <= Date.now();
      const active = r && ["active", "test"].includes(r.status) && !expired && (shared || !r.redeemed);
      let title = text("general.feedback_saved");
      if (!shared && r?.redeemed) title = text("general.reward_redeemed");
      else if (expired) title = text("general.reward_expired");
      else if (active) title = text(shared ? "general.shared_reward_ready" : "general.reward_ready");
      stage.innerHTML = `<h1 class="d ish-surprise__title">${esc(title)}</h1>${active ? `<p class="ish-surprise__reward-intro">${esc(text("general.reward_code_intro"))}</p><div class="ish-surprise__reward-code"><strong>${esc(r.code)}</strong><button type="button" data-copy>${esc(text("general.copy"))}</button></div>${shared ? fine(true) : `<p class="ish-surprise__expiry">${esc(text("general.valid_until", { date: new Date(r.expiresAt).toLocaleDateString() }))}</p>${fine()}`}${demo ? `<p class="ish-surprise__fine">${esc(text("general.preview_code"))}</p>` : ""}` : r?.status === "pending" ? `<p class="ish-surprise__helper" role="status">${esc(text("general.preparing_reward"))}</p><button class="ish-surprise__primary" data-refresh>${esc(text("general.refresh"))}</button>` : ""}${error()}`;
      stage.querySelector("[data-copy]")?.addEventListener("click", async () => { try { await navigator.clipboard.writeText(r.code); stage.querySelector("[data-copy]").textContent = text("general.copied"); } catch { stage.querySelector("[data-copy]").textContent = text("general.select_code"); } });
      stage.querySelector("[data-refresh]")?.addEventListener("click", reloadReward);
      if (active) {
        offers.innerHTML = root.querySelector("[data-packs-template]").innerHTML;
        offers.hidden = false;
        event("offer_viewed");
        offers.querySelectorAll("[data-pack]").forEach(anchor => {
          const pack = anchor.dataset.pack;
          if (demo) {
            const product = new URL(anchor.href, location.href);
            product.searchParams.set("view", "first-purchase-reward");
            product.searchParams.set("reward_kind", "shared");
            const current = new URL(location.href);
            const previewId = current.searchParams.get("preview_theme_id") || (window.Shopify?.theme?.role === "development" ? String(window.Shopify.theme.id) : "");
            if (previewId && /^\d+$/.test(previewId)) product.searchParams.set("preview_theme_id", previewId);
            anchor.href = product.href;
          } else {
            const apply = new URL(`${apiBase}/api/${shared ? "unboxing-apply" : "apply"}`);
            apply.searchParams.set("token", token); apply.searchParams.set("pack", pack);
            if (shared) apply.searchParams.set("entry_source", state.entrySource);
            const product = new URL(anchor.href, location.href);
            const current = new URL(location.href);
            const variant = product.searchParams.get("variant") || current.searchParams.get("variant");
            const previewId = current.searchParams.get("preview_theme_id") || product.searchParams.get("preview_theme_id") || (window.Shopify?.theme?.role === "development" ? String(window.Shopify.theme.id) : "");
            if (variant && /^\d+$/.test(variant)) apply.searchParams.set("variant", variant);
            if (previewId && /^\d+$/.test(previewId)) apply.searchParams.set("preview_theme_id", previewId);
            anchor.href = apply.href;
          }
          anchor.onclick = async e => {
            if (!shared || demo) { event(`pack_${pack}_clicked`); return; }
            e.preventDefault();
            if (state.busy) return;
            state.busy = true; state.error = "";
            anchor.textContent = text("general.unlocking");
            offers.querySelectorAll("[data-pack]").forEach(item => item.setAttribute("aria-disabled", "true"));
            event(`pack_${pack}_clicked`);
            try {
              const handoff = new URL(anchor.href);
              handoff.pathname = "/api/unboxing-handoff";
              const data = await api(handoff.pathname.slice(5) + handoff.search);
              const destination = new URL(data.destinationUrl);
              const discount = new URL(data.discountUrl);
              const paths = { "3": "/products/3-pack-inshape-beaters-size-up", "5": "/products/5-pack-inshape-compression-tanks-1" };
              const commerceToken = new URLSearchParams(destination.hash.slice(1)).get("unboxing_reward");
              if (destination.origin !== location.origin || destination.pathname !== paths[pack] || destination.searchParams.get("view") !== "first-purchase-reward" || destination.searchParams.get("reward_kind") !== "shared" || tokenPurpose(commerceToken) !== "unboxing_reward" || discount.origin !== location.origin || discount.pathname !== `/discount/${encodeURIComponent(r.code)}` || discount.searchParams.get("redirect") !== "/cart.js" || data.reward?.status !== "active" || data.reward?.kind !== "shared" || data.reward?.currency !== "USD" || data.reward?.discountCode !== r.code || data.reward?.amount !== 20 || data.reward?.minimumSubtotal !== 0 || data.reward?.includesFreeShipping !== false || data.reward?.expiresAt !== null) throw new Error(text("errors.connection"));
              persistOrderAttribution(data);
              const applied = await fetch(discount.href, { credentials: "same-origin", cache: "no-store", referrerPolicy: "no-referrer", signal: AbortSignal.timeout(30000) });
              if (!applied.ok) throw new Error(text("errors.connection"));
              if (window.InShapeUnboxingQA) await window.InShapeUnboxingQA.flushJourney(750);
              location.assign(destination.href);
            } catch (error) {
              state.busy = false; state.error = error.message || text("errors.connection"); render(false);
            }
          };
        });
      }
      if (r?.status === "pending" && polls < 60 && !preview) { polls++; pollTimer = setTimeout(reloadReward, 10000); }
    }
    async function reloadReward() {
      try {
        const data = await api(`${tokenKind === "shared" ? "unboxing-response" : "response"}?token=${encodeURIComponent(token)}`);
        if (data.questionnaire !== "unboxing") throw new Error(text("errors.wear_link"));
        Object.assign(state, { reward: data.reward, revision: data.revision, isTest: data.isTest, completed: data.completed }); persistOrderAttribution(data); state.error = ""; save();
      } catch (e) { state.error = e.message; }
      render(false);
    }
    function failure() {
      stage.innerHTML = `<p class="ish-surprise__eyebrow">${esc(text("general.failure_eyebrow"))}</p><h1 class="d ish-surprise__title">${esc(text("general.failure_title_first"))}<br>${esc(text("general.failure_title_second"))}</h1><p class="ish-surprise__helper">${esc(state.error || text("errors.open_personal_link"))}</p><button class="ish-surprise__primary" data-fresh-start>${esc(text("general.reveal_again"))}</button>`;
      stage.querySelector("[data-fresh-start]").onclick = freshStart;
    }
    function freshStart() {
      try { sessionStorage.removeItem("inshape.unboxing.personal-link"); sessionStorage.removeItem(storageKey); sessionStorage.removeItem(previousStorageKey); } catch {}
      const url = new URL(location.href); url.hash = ""; url.searchParams.delete("token"); url.searchParams.delete("experience_view"); url.searchParams.delete("reward_kind");
      if (["verify", "reward"].includes(url.searchParams.get("view"))) url.searchParams.delete("view");
      location.replace(url.href);
    }
    if (preview) {
      root.querySelector("[data-preview-bar]").hidden = false;
      root.querySelector("[data-reset]").onclick = () => { clearTimeout(chooseTimer); state = { ...state, phase: "game", step: 0, answers: {}, completed: false, reward: null, busy: false, error: "", quizFinished: false, pendingAnswer: null, submissionKey: "", submissionFingerprint: "" }; token = ""; tokenKind = "legacy"; save(); render(); window.scrollTo({ top: 0 }); };
    }
    async function start() {
      if (!preview && token) {
        if (link.view === "verify" && tokenPurpose(token) === "verify" && tokenKind !== "shared") state.phase = "verify";
        else {
          try {
            const purpose = tokenPurpose(token);
            if (purpose !== (tokenKind === "shared" ? "unboxing" : "survey")) throw new Error(text("errors.open_personal_link"));
            const data = await api(`${tokenKind === "shared" ? "unboxing-response" : "response"}?token=${encodeURIComponent(token)}`);
            if (data.questionnaire !== "unboxing") throw new Error(text("errors.personal_wear_link"));
            Object.assign(state, { answers: data.answers, revision: data.revision, reward: data.reward, completed: data.completed, isTest: data.tracking?.isTest === true || data.isTest === true, variant: data.experimentVariant || "cards", visit: data.tracking?.visitId || data.journeyId || state.visit, entrySource: entrySources.includes(requestedSource) ? requestedSource : data.tracking?.entrySource || initialEntrySource });
            persistOrderAttribution(data);
            state.answers = cleanDraft(data.answers);
            const steps = activeQuestions();
            const missing = steps.findIndex(q => q.required && !hasAnswer(q, state.answers));
            state.step = missing === -1 ? steps.length - 1 : missing;
            state.phase = data.completed ? "reward" : "questions"; state.quizFinished = data.completed === true; save();
          } catch (e) { state.phase = "failure"; state.error = e.message; }
        }
      } else if (!preview) {
        try { const data = await api("experience-config"); if (data.experimentEnabled && !hadVariant) state.variant = ["cards", "wheel", "scratch"][crypto.getRandomValues(new Uint32Array(1))[0] % 3]; save(); } catch {}
      }
      event("experience_opened"); render(false);
    }
    start();
  }
  document.querySelectorAll("[data-inshape-surprise]").forEach(mount);
  document.addEventListener("shopify:section:load", event => event.target.querySelectorAll("[data-inshape-surprise]").forEach(mount));
})();
